import { moduleColor } from './graphColors';
import { recordCode } from '../header/recordCode';
import type { IGraphNodeViewProps } from './IGraphNodeViewProps';

/** Обрізає підпис вузла до `max` символів з «…». */
const clip = (s: string, max: number) => (s.length > max ? `${s.slice(0, max - 1)}…` : s);

/**
 * Вузол навігатора (прототип v4): центр — заповнене коло 30px з номером білим (без префікса типу); перший рівень — коло 18px з рамкою кольору модуля,
 * код усередині, назва й тип запису під колом; далі — менші кола 12px. Клік — у центр, тягнення — перемістити.
 */
export function GraphNodeView({ node, x, y, center, typeLabel, onPointerDown }: IGraphNodeViewProps) {
  const r = center ? 30 : node.level === 1 ? 18 : 12;
  const tone = moduleColor(node.module);
  const code = recordCode(node.display);
  return (
    <g className="rec-nav__node" transform={`translate(${x} ${y})`} onPointerDown={(e) => onPointerDown(e, node)} role="button" aria-label={`${code} ${node.title}`}>
      <title>{`${typeLabel} ${code} · ${node.title}`}</title>
      <circle r={r} fill={center ? '#0f766e' : 'var(--surface)'} stroke={center ? '#0f766e' : tone} strokeWidth={center ? 0 : node.level === 1 ? 2 : 1.5} />
      <text className="rec-nav__code" textAnchor="middle" dy="0.35em" fill={center ? '#fff' : tone} fontSize={center ? 12 : node.level === 1 ? 9.5 : 7.5}>{clip(code, center ? 10 : 8)}</text>
      <text className="rec-nav__label" textAnchor="middle" y={r + 13} fontSize={center ? 11.5 : node.level === 1 ? 10.5 : 9}>{clip(node.title, center ? 34 : node.level === 1 ? 24 : 18)}</text>
      {node.level <= 1 && <text className="rec-nav__type" textAnchor="middle" y={r + 25} fontSize={9.5}>{typeLabel}</text>}
    </g>
  );
}
